module.exports = __webpack_public_path__ + "static/media/component.module.e5af77fa.less";